import { Pipe, PipeTransform } from '@angular/core';
import { LoggerService } from '@wdpr/ra-angular-logger';
import moment from 'moment';

const loggerBaseMessage = 'Time Period Pipe -';

@Pipe({name: 'TimePeriod', standalone: true})
export class TimePeriodPipe implements PipeTransform {

    constructor(private logger: LoggerService) {
    }

    /**
     * Transforms a string time to a ISO 8601 durations format used in datetime attribute from <time> tags.
     * An invalid string time will result in a "P0D" duration string.
     *
     * Durations accepts the following time string format: "d.HH:mm:ss.SS"
     *
     * @example "1:30:00" => "PT1H30M" (one hour, thirty minutes)
     *          "1 2:45:30" => "P1DT2H45M30S" (one day, two hours, forty five minutes and thirty seconds)
     *          "xxxxx" => "P0D" (zero days)
     *
     * @param value
     * @returns
     */
    transform(value: string): string {
        const duration = moment.duration(value);
        const transformed = duration.toString();

        // As of moment v2.22.2, duration is invalid only if it receives NaN as a param to its constructor.
        // In upcoming releases, durations are expected to cover more invalid cases.
        if (!(duration as any).isValid() || transformed === 'P0D') {
            this.logger.error(
                `${loggerBaseMessage} Cannot create a valid moment.duration object. The time provided isn't valid.`,
            );
        }

        return transformed;
    }
}
